// extracted by mini-css-extract-plugin
module.exports = {"titleCaseHeader":"style_titleCaseHeader__g1PC4","titleCaseHeader__title":"style_titleCaseHeader__title__i8ZCv","titleCaseHeader__subtitle":"style_titleCaseHeader__subtitle__GMupP"};